export interface DictionaryCollectionValue {
  label: string;
  value: string
}
export enum DictionaryType {
  GENDER = 'GENDER',
  WINE_TYPE = 'WINE_TYPE',
  WINE_FLAVOUR = 'WINE_FLAVOUR',
  EAT_WITH_WINE = 'EAT_WITH_WINE',
  WINE_COUNTRY = 'WINE_COUNTRY',
  WINE_DRINK_TIME = 'WINE_DRINK_TIME',
  WINE_BUDGET = 'WINE_BUDGET',
  WINE_TASTE = 'WINE_TASTE',
  CONDITIONAL_STATUS = 'CONDITIONAL_STATUS',
}

export type DictionaryCollection = {
  [key in Partial<DictionaryType>]: DictionaryCollectionValue[];
};
